export const environment = {
  'production': true,
  'proxy': 'https://proxy.swaas.de',
  'mcp': 'https://mcp.swaas.de/',
  'MCP_CLIENTS_JSON': 'https://mcp.swaas.de/clients.json',
  'clientID': 919,
  'apiURL': 'https://vtw-dev-api.plusservices.de',
  'appVersion': require('../../package.json').version,
  'ngVersion': require('../../package.json').dependencies['@angular/pwa'],
  'appName' : 'Stadtwerke Münster Dashboard'
}
